import { Box, Link, Stack, Typography } from '@mui/material';
import { useSystemActions } from 'stores';
import { Swiper, SwiperSlide } from 'swiper/react';
import { dynamicObjectType } from 'types';

interface ImageCarouselProps {
	imgs?: string[];
	verifyCode?: string;
	obejctsContainImage?: Array<dynamicObjectType>;
}

const ImageCarousel = (props: ImageCarouselProps) => {
	const { imgs, verifyCode, obejctsContainImage } = props;
	const { getImage } = useSystemActions();

	return (
		<>
			<Box>
				{!obejctsContainImage && imgs ? (
					<Swiper slidesPerView={1} pagination={{ clickable: true }}>
						{imgs.map((img, index) => (
							<SwiperSlide key={index}>
								<Stack direction="row" justifyContent="center">
									<Box
										component="img"
										sx={{
											paddingBottom: '30px',
											height: '56.25vw',
											maxWidth: '100%',
											objectFit: 'contain',
										}}
										alt="image"
										src={`${process.env.REACT_APP_DOMAIN_NAME}${process.env.REACT_APP_API_GET_IMAGE}?name=${img}`}
									/>
								</Stack>
							</SwiperSlide>
						))}
						{
							/*((status === 'success' && qrCodeType === 2) || (status === 'success' && verifyStatus === 3)) &&*/
							verifyCode === 'msg_code_successful' ||
							verifyCode === 'msg_code_AxRQR_ok_wait_hide_code' ||
							verifyCode === 'msg_code_AxRQR_ok_wait_auth_code' ||
							verifyCode === 'msg_code_AxRQR_ok_successful' ||
							verifyCode === 'msg_code_single_success' ||
							verifyCode === 'msg_code_AxRQR_ok_wait_code' ||
							verifyCode ===
								'msg_code_AxRQR_stateless_repetitive_self' ||
							verifyCode === 'msg_code_repetitive_self' ? (
								<Box
									sx={{
										position: 'absolute',
										zIndex: 1,
										width: '40%',
										right: '3%',
										bottom: '15%',
										transform: 'rotate(-10deg)',
									}}
									component="img"
									alt="Authen_Success"
									src={getImage('Authen_Success.png')}
								/>
							) : verifyCode === 'msg_code_recalled_fail' ? (
								<Box
									sx={{
										position: 'absolute',
										zIndex: 1,
										width: '40%',
										right: '3%',
										bottom: '15%',
										transform: 'rotate(-10deg)',
									}}
									component="img"
									alt="Authen_Success"
									src={getImage('Recalled.png')}
								/>
							) : null
						}
					</Swiper>
				) : obejctsContainImage && !imgs ? (
					<Swiper slidesPerView={1} pagination={{ clickable: true }}>
						{obejctsContainImage.map((object, index) => (
							<SwiperSlide key={index}>
								<Stack direction="row" justifyContent="center">
									<Link
										href={object.imageLink}
										target={'_blank'}
									>
										<Box
											component="img"
											sx={{
												width: '100%',
											}}
											alt="image"
											src={`${process.env.REACT_APP_DOMAIN_NAME}${process.env.REACT_APP_API_GET_IMAGE}?name=${object['image']}`}
										/>
									</Link>
								</Stack>
								<Typography>{object.message}</Typography>
							</SwiperSlide>
						))}
					</Swiper>
				) : (
					<>
						Please take notes current component only support either
						pass in image list or objects contains iamge
					</>
				)}
			</Box>
		</>
	);
};

export default ImageCarousel;
